import {createSlice} from '@reduxjs/toolkit';
import {WundergroundUserLink} from '../../api/types';

type Props = {
  link: WundergroundUserLink | null;
};

export const wundergroundSlice = createSlice({
  name: 'wunderground',
  initialState: {
    link: null,
  } as Props,
  reducers: {
    setWundergroundUserLink: (
      state,
      {payload: link}: {payload: WundergroundUserLink},
    ) => {
      if (state.link === null || link === null) {
        state.link = link;
      } else {
        // mergeDeep in order to keep generic_station key which is not present for station list
        const oldWeatherStations = state.link.account.weather_stations;
        const newWeatherStations = link.account.weather_stations;

        state.link = link;
        const mergedWeatherStations = [];
        newWeatherStations.forEach((newItem) => {
          const oldStation = oldWeatherStations.find(
            (oldItem) => oldItem.device_id === newItem.device_id,
          );
          if (oldStation) {
            mergedWeatherStations.push({...oldStation, ...newItem});
          } else {
            mergedWeatherStations.push(newItem);
          }
        });
        state.link.account.weather_stations = mergedWeatherStations;
      }
    },
  },
});

export const {setWundergroundUserLink} = wundergroundSlice.actions;

export default wundergroundSlice.reducer;
